import Base from "../../base";
import { useTranslation } from "react-i18next";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import Title from "../../../components/ui/Title";
import SearchItem from "../../../components/ui/Forms/SearchItem";
import { faDolly } from "@fortawesome/pro-regular-svg-icons";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ItemsList from "./ItemsList";
import axiosConfig from "../../../services/Axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudUploadAlt,
  faHandHoldingMedical,
} from "@fortawesome/pro-solid-svg-icons";
import dayjs from "dayjs";

function Items() {
  const [items, setItems] = useState(false);
  const [formData, setFormData] = useState();
  const authUser = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    loadItems(formData);
  }, [formData]);

  const loadItems = () => {
    let itemsPerPage = 10;

    let url =
      process.env.REACT_APP_API_URL +
      (formData?.page ? formData?.page + "&" : "/api/items?pagination=true");

    if (itemsPerPage) {
      url = url + "&itemsPerPage=" + itemsPerPage;
    }

    if (formData?.name) {
      url = url + "&name=" + formData.name;
    }

    if (formData?.itemCategory) {
      url = url + "&itemCategory=" + formData.itemCategory;
    }

    if (formData?.itemSubCategory) {
      url = url + "&itemSubCategory=" + formData.itemSubCategory;
    }

    axiosConfig.get(url).then((response) => {
      if (response?.status === 200 && response?.data) {
        setItems(response.data);
      }
    });
  };

  const handleExportItems = (data) => {
    const params = {
      name: data?.name ? data.name : null,
      itemCategory: data?.itemCategory ? data.itemCategory : null,
      itemSubCategory: data?.itemSubCategory ? data.itemSubCategory : null,
    };

    let filename = "export-articles-" + dayjs().format("YYYY-MM-DD-HH:mm");
    let urlParams = Object.keys(params).map(value => params[value] ? (`${value} = ${encodeURIComponent(params[value])}`) : '').join('&');

    axiosConfig
      .get(process.env.REACT_APP_API_URL + "/api/items/export?" + urlParams, {
        responseType: "arraybuffer",
      })
      .then(async (response) => {
        if (response.data) {
          let b = new Blob([response.data]);
          const url = window.URL.createObjectURL(b);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 lg:p-8 lg:px-10 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10 lg:bg-white rounded-lg">
          <Title
            icon={faDolly}
            title={
              authUser?.user?.roles.includes("ROLE_ADMIN")
                ? t("settings.items.list")
                : t("settings.items.listUser")
            }
            button={{
              label: t("settings.items.create"),
              icon: <FontAwesomeIcon icon={faHandHoldingMedical} />,
              fn: () => navigate("/settings/items/create"),
            }}
          />

          <SearchItem
            setFormData={setFormData}
            formData={formData}
            className="p-4 px-6 mb-4 bg-gray-100"
          />

          <Title
            title={t("global.resultCount", {
              count: items["hydra:totalItems"] ?? 0,
            })}
            button={{
              icon: <FontAwesomeIcon icon={faCloudUploadAlt} />,
              label: t("global.export"),
              fn: () => handleExportItems(formData),
            }}
          />

          <ItemsList
            items={items}
            setItems={setItems}
            loadItems={loadItems}
            setFormData={setFormData}
          />
        </div>
      </div>
    </Base>
  );
}

export default Items;
